export default function authHeader() {
    let token = localStorage.getItem('auth-token');
    // console.log(user.access_token)
  
    if (token) {
      return { Authorization: 'Bearer ' + token };
    } else {
      return {};
    }
  }